import {DG_axios} from "../../../../../custom/axios";
import {DG_axiosNormal} from "../../../../../custom/axios/normal";

const BASE_URI = `/dogoo/timekeeping-rest/v2.0/attendance/location`;

export const loadDetailSettingLocation = async(id) => {
    const response = await DG_axios.get(BASE_URI + "/" + id);

    return response.data || []
};
export const loadSettingLocations = async(params) => {
    const config = {params: params};

    const response = await DG_axios.get(BASE_URI ,config);

    return response.data || []
};

export const addSettingLocation = async(data) => {
    const response = await DG_axios.post(BASE_URI, data);

    return response.data || []
};
export const deleteSettingLocation = async(id) => {
    const response = await DG_axios.delete(
        BASE_URI + "/" + id
    );

    return response.data || []
};
export const updateStatusSettingLocation = async(id,status) => {
    const response = await DG_axios.get(
        BASE_URI + "-status" + "/" + id + `?status=${status}`
    );

    return response.data || []
};

export const updateLocation = async(id, data) => {
    const response = await DG_axios.put(BASE_URI + "/" + id, data);

    return response.data || []
};

export const getOnlyTotalLocationRequest = async( type,apiKey) => {
    const response = await DG_axiosNormal.get(`${BASE_URI}/request-all?apiKey=${apiKey}&type=${type}`);

    return response.data || []
};


export const getTotalLocationRequest = async( type,apiKey) => {
    const response = await DG_axiosNormal.get(`${BASE_URI}/request?apiKey=${apiKey}&type=${type}`);

    return response.data || []
};

